import React, { createElement, FC, ReactElement, ReactNode } from "react";

import { OrganizationDto } from "@intelligems/ig-types";
import { useGetOrg } from "@src/api/organizations/get-organization";
import { useIsAdmin } from "@src/api/user-auths/is-admin";
import { NoAccessRoute } from "@src/domains/Settings/NoAccessRoute";
import Loading from "@src/utils/Loading";

interface FeatureRoute2Props {
  adminOnly?: boolean;
  allowAdminBypass?: boolean;
  children: any;
  disabledComponent?: ReactNode;
  customTooltip?: ReactElement<any>;
  message?: string;
  debugId: string;
  isEnabled: ({
    org,
    isAdmin,
  }: {
    org: OrganizationDto;
    isAdmin: boolean;
  }) => boolean;
  componentProps?: any;
}

export const ScopedRoute: FC<FeatureRoute2Props> = ({
  adminOnly,
  allowAdminBypass = true,
  children,
  disabledComponent,
  customTooltip,
  debugId,
  isEnabled,
  componentProps,
  ...props
}) => {
  const org = useGetOrg();
  const isAdmin = useIsAdmin();

  // `useIsAdmin` returns `undefined` while the admin lookups are in flight.
  // Treating that as "not an admin" paints the No Access screen on the first
  // render of every admin-gated route, so hold the same loading state the
  // logged-in suspense boundary uses until the answer is known.
  if (isAdmin === undefined) {
    return <Loading />;
  }

  if (
    (allowAdminBypass && isAdmin) ||
    isEnabled({
      org: org.data.org,
      isAdmin,
    })
  ) {
    return createElement(children, componentProps);
  }
  return <NoAccessRoute message={"No Access"} />;
};
